import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';
import Button from '../../Button';

const EmptyValue = styled.div`
  height: 100%;
  opacity: 0.4;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    border-top: 2px solid ${(props) => props.theme.colors.dark};
    width: 12px;
  }
`;

const Cell = ({ value, onClick, ...otherProps }) => (
  <CellContainer {...otherProps}>
    {value ? (
      <Button
        onClick={onClick}
        label={value}
        textTransform="normal"
        height="30px"
        width="100px"
        fontSize="12px"
      />
    ) : (
      <EmptyValue>
        <div />
      </EmptyValue>
    )}
  </CellContainer>
);

export default Cell;
